import React from 'react';
import { useState } from "react";

export const useCounter = (initialValue = 0) => {
	const [count, setCount] = useState(initialValue);
	return {
		active: count > 0,
		inc: () => setCount(prev => prev + 1),
		dec: () => setCount(prev => Math.max(0, prev - 1)),
	};
};
